/**
 * Single source for "main category" display strings across every product
 * exception + Product Catalogue Review. Centralises the null/empty -> "No
 * category" wording so column, subtitle, filter dropdown, and Excel
 * export all read the same.
 *
 * Forward-compatible signature: if a future product exception grows
 * multi-category support, add a `string[]` overload here (e.g. emit
 * "Multi (N)") and every caller picks it up without changing.
 */

export const NO_CATEGORY_LABEL = 'No category'

/**
 * Sentinel value used in multiselect filters for the "no main category"
 * bucket. Backend rows with `category_root_name = null` map to this value;
 * the dropdown option carries the user-facing `NO_CATEGORY_LABEL`. Real
 * category names cannot collide with this string.
 */
export const NO_CATEGORY_VALUE = '__no_category__'

export const isMissingCategory = (
  name: string | null | undefined,
): boolean => name == null || String(name).trim() === ''

export const formatMainCategory = (
  name: string | null | undefined,
): string => {
  if (isMissingCategory(name)) return NO_CATEGORY_LABEL
  return String(name).trim()
}
